export const api = {
  getBoard: (params = null) => ({
    url: '/board/board_types/NoticeBoard/get_named/',
    params: {
      ...params,
      name: '윙크자료실',
    },
  }),
  getBoardCategory: (postCategoryTagId) => ({
    url: `/aux/tags/${postCategoryTagId}/`,
    params: {},
  }),
  getBoardList: (id, params) => ({
    url: `/board/boards/${id}/posts/`,
    params: {
      ...params,
      status: 0,
      need_html: true,
    },
  }),
  createDownloadLog: (actorId, params) => ({
    url: '/aux/logs/',
    params: {
      model_type: 96,
      actor: actorId,
      data: {
        ...params,
      },
    },
  }),
};

export default api;
